export default __webpack_public_path__ + "static/media/Komment.12890c96.png";